import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import {API, graphqlOperation} from 'aws-amplify';
import {listProducts} from '../../graphql/queries';
import * as mutations from '../../graphql/mutations';

const initialState = {
  items: [],
  status: 'idle',
  error: null,
  updateError: null
}

export const addNewProduct = createAsyncThunk(
  'products/addNewProduct',
  async (newProduct) => {
    const response = await API.graphql(graphqlOperation(mutations.createProduct, {input: newProduct}))
    return response.data.createProduct
  }
)

export const updateProduct = createAsyncThunk(
  'products/updateProduct',
  async (product) => {
    try {
      const response = await API.graphql({ query: mutations.updateProduct, variables: {input:
            {id: product.id, name: product.name, description: product.description, price: product.price,
              cost: product.cost, sku: product.sku, image: product.image} }})
      return response.data.updateProduct
    } catch(err) {
      console.log(`Error in thunk: ${JSON.stringify(err)}`)
    }
  }
)

export const deleteProduct = createAsyncThunk(
  'products/deleteProduct',
  async (id) => {
    try {
      const response = await API.graphql({ query: mutations.deleteProduct, variables: {input: {id} }})
      return id
    } catch(error) {
      console.log(`Error deleting product`)
    }
  }
)

export const fetchProducts = createAsyncThunk('products/fetchProducts', async () => {
  const response = await API.graphql(graphqlOperation(listProducts))
  return response.data.listProducts.items
})

const productsSlice = createSlice({
  name: 'products',
  initialState,
  reducers: {
    /*
    productUpdated(state, action) {
      state.push(action.payload)
    }*/
  },
  extraReducers(builder) {
    builder
      .addCase(fetchProducts.pending, (state, action) => {
        state.status = 'loading'
      })
      .addCase(fetchProducts.fulfilled, (state, action) => {
        state.status = 'succeeded'
        // Add any fetched posts to the array
        state.items = state.items.concat(action.payload)
      })
      .addCase(fetchProducts.rejected, (state, action) => {
        state.status = 'failed'
        state.error = action.error.message
      })
      .addCase(addNewProduct.fulfilled, (state, action) => {
        state.items.push(action.payload)
      })
      .addCase(updateProduct.fulfilled, (state, action) => {
        const newState = state.items.filter(product => product.id !== action.payload.id)
        state.items = [...newState, action.payload]
      })
      .addCase(deleteProduct.fulfilled, (state, action) => {
        state.items = state.items.filter(product => product.id !== action.payload)
      })
  },
})

export const { productAdded } = productsSlice.actions

export default productsSlice.reducer

export const selectAllProducts = (state) => state.products.items
